import style from "./style.scss";
import { mergeClasses } from "../helpers";

const BigBlock = ({ uppercase = false, children }) => (
  <span
    class={mergeClasses([style.bigBlock, uppercase ? style.uppercase : null])}
  >
    {children}
  </span>
);

export default BigBlock;
